import { render, staticRenderFns } from "./OrderPartnerMain.vue?vue&type=template&id=3897a22c&scoped=true&"
import script from "./OrderPartnerMain.vue?vue&type=script&lang=js&"
export * from "./OrderPartnerMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3897a22c",
  null
  
)

export default component.exports